import {
  validateLength,
  validatePresence
} from "ember-changeset-validations/validators";

export default {
  twoFactorCode: [
    validatePresence({
      presence: true,
      description: "Le code d'authentification"
    }),
    validateLength({ is: 4, description: "Le code d'authentification" })
  ]
};
